<template>
  <div :class="{'tg-card-group': true, 'bottom-border': bottomBorder}">
    <a :href="data.locationlink == null ? '/e3/news/' + (data.id || data.nid) : data.locationlink">
      <tg-flexbox>
        <div class="tg-card-group_left">
          <img :src="'https://xyoss.g.com.cn/xy-production' + data.banner"
               alt="">
        </div>
        <tg-flexbox direction="column"
                    class="tg-card-group_right">
          <tg-flexbox class="tg-card-group_title">{{data.titlefull}}</tg-flexbox>
          <tg-flexbox class="tg-card-group_infobox">
            <tg-flexbox flex="none"
                        class="text"
                        :style="{color: showColor}">{{label == '' ? tag : label}}</tg-flexbox>
            <tg-flexbox flex="none"
                        class="line"
                        v-if="tag!=''"></tg-flexbox>
            <tg-flexbox flex="none"
                        class="line"
                        v-if="label!=''"></tg-flexbox>
            <tg-flexbox flex="none"
                        class="time">{{data.displaydate | timestampToTimeNoYear}}</tg-flexbox>
          </tg-flexbox>
        </tg-flexbox>
      </tg-flexbox>
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tagColors: ['#EE6F00', '#0098EE', '#E60012', '#13B929', '#262626'],
      getTags: ['E3图赏', 'E3视频', 'E3采访', 'E3试玩', 'E3新闻'],
      showTags: ['前线', '视频', '采访', '试玩', '资讯'],
      showColor: '',
      tag: '',
    };
  },
  name: 'TgCardGroup',
  props: {
    bottomBorder: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'tgbuswap_360mw',
    },
    colorInfo: {
      type: String,
      default: 'zixun',
    },
    label: {
      type: String,
      default: '',
    },
    data: Object,
  },
  created() {
    const self = this;
    if (!self.label) {
      const tags = this.data.tags || [];
      let index = 0;
      self.showColor = self.tagColors[4];
      self.tag = self.showTags[4];
      tags.forEach(item => {
        index = self.getTags.indexOf(item);
        if (index > -1) {
          self.showColor = self.tagColors[index];
          self.tag = self.showTags[index];
          return;
        }
      });
    } else {
      let index = self.showTags.indexOf(self.label);
      self.showColor = self.tagColors[index];
    }
  },
};
</script>
